export default "__VITE_ASSET__DRseaQ3P__"